import iconProperty from "assets/works/icon_property.png";
import iconProject from "assets/works/icon_project.png";
import iconMarketing from "assets/works/icon_marketing.png";
import iconReport from "assets/works/icon_report.png";
import iconContact from "assets/works/icon_contact.png";
import iconLead from "assets/works/icon_lead.png";
import iconOpportunity from "assets/works/icon_opportunity.png";
import iconDocument from "assets/works/icon_document.png";
import iconUserGroup from "assets/works/icon_user_group.png";
import iconLocation from "assets/works/icon_location.png";
import iconBell from "assets/works/icon_bell.png";
import imagePromote from "assets/works/image_promote.png";
import iconWeb from "assets/works/icon_web.png";
import iconSetting from "assets/works/icon_setting.png";
import iconListing from "assets/works/icon_listing.png";
import imageConnectors from "assets/works/image_connectors.png";
import iconNews from "assets/works/icon_news.png";
import iconSocial from "assets/works/icon_social.png";
import imageMarketing from "assets/works/image_marketing.png";
import iconAnnounce from "assets/works/icon_announce.png";
import iconEditPencil from "assets/works/icon_edit_pencil.png";
import imageHelpDesk from "assets/works/image_help_desk.png";
import iconHeadPhone from "assets/works/icon_heahphone.png";
import iconRefresh from "assets/works/icon_refresh.png";
import imageNetworking from "assets/works/image_networking.png";
import iconNavigationBoard from "assets/works/icon_navigation_board.png";
import iconGrow from "assets/works/icon_grow.png";

export const WorksData = [
    {
        title: "Real Estate CRM Software-complete real estate crm solution",
        subtitle: "Trusted by Indian Realtors, Brokers, Agents and Marketplace",
        isImage: false,
        image: null,
        imagePosition: "",
        coloredBG: true,
        leftIconWithText: [
            {
                icon: iconProperty,
                title: "Property Management",
                text: "Manage every aspect of property management from a single app.",
            },
            {
                icon: iconProject,
                title: "Project Management",
                text: "Real estate projects can vary from simple transactions to complex deals that require skilled negotiation.",
            },
            {
                icon: iconMarketing,
                title: "Marketing and Campaign Management",
                text: "It is a wide-ranging effort, involving several stages including: planning, executing, tracking, and analyzing/optimizing a campaign.",
            },
            {
                icon: iconReport,
                title: "Report Generation and Distribution",
                text: "Gain flexibility in your reporting processes with automated report generation, saving time and improving accuracy.",
            }
        ],
        rightIconWithText: [
            {
                icon: iconContact,
                title: "Contact Management",
                text: "Contact Management is an online software that allows you to organize contacts, tasks, and deals all in one place, streamlining your workflow and enhancing productivity.",
            },
            {
                icon: iconLead,
                title: "Lead Management",
                text: "Reduce response time by automating follow-up communications as soon as a new property inquiry is received",
            },
            {
                icon: iconOpportunity,
                title: "Opportunity Management",
                text: "Streamline opportunities with a comprehensive Real Estate CRM built to help you sell more effectively. This CRM features streamlined lead tracking, account management, inventory control, and more, with all your business data in one place.",
            },
            {
                icon: iconDocument,
                title: "Document Management",
                text: "Cloud Document Management System Software for Indian Realtors.",
            }
        ]
    },
    {
        title: "Simple Mobile App CRM",
        subtitle: "Watch your entire closely even miles away",
        isImage: false,
        image: null,
        imagePosition: "",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconUserGroup,
                title: "Make your mobile a lead capture machine",
                text: "Leads from all your online channels (like Facebook, Twitter, website, etc.) are automatically captured and assigned to the relevant salespeople for efficient follow-up and conversion.",
            },
            {
                icon: iconLocation,
                title: "Geo track your team to lead them effectively",
                text: "Get a complete activity history of your team members at the end of the day. Review their performance and provide insights to enhance efficiency and productivity.",
            },
            {
                icon: iconBell,
                title: "Timely Notifications for Scheduled Visits and Important Tasks",
                text: "Stay organized with timely notifications for scheduled visits and key tasks, ensuring nothing is overlooked. This feature helps you manage your day efficiently and meet deadlines consistently.",
            }
        ],
        rightIconWithText: null
    },
    {
        title: "Promote your real estate business on the internet",
        subtitle: "Launch and Manage Your Real Estate Website Under Your Brand Name",
        isImage: true,
        image: imagePromote,
        imagePosition: "left",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconWeb,
                title: "Fully Responsive Design Layout",
                text: "A fully responsive design layout ensures your website adapts seamlessly to any device, providing an optimal viewing experience across desktops, tablets, and smartphones.",
            },
            {
                icon: iconSetting,
                title: "Advanced Template Options",
                text: "Access a variety of customizable, advanced templates designed to meet the unique needs of your real estate business, allowing for a personalized and professional online presence",
            },
            {
                icon: iconListing,
                title: "Unlimited Property and Project Listings",
                text: "Easily add and manage an unlimited number of property and project listings, ensuring your real estate offerings are always up-to-date and easily accessible.",
            }
        ],
        rightIconWithText: null
    },
    {
        title: "Real Estate Connectors",
        subtitle: "Unify all your real estate lead generation channels",
        isImage: true,
        image: imageConnectors,
        imagePosition: "right",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconNews,
                title: "Real estate marketplaces",
                text: "Sync enquiries from all real estate marketplace - 99Acres, Common Floor, MagicBricks, Housing, Makaan, Property Bazaar, JustDial and other through direct connectors or APIs.",
            },
            {
                icon: iconSocial,
                title: "Social media, website etc.",
                text: "Capture all enquiries from your website, Youtube, Facebook, Linkedln and others, directly using landing pages and plug-nad-play social integrations.",
            }
        ],
        rightIconWithText: null
    },
    {
        title: "All the WhatsApp, Email, SMS or IVR marketing features you really need!",
        subtitle: "Capture property enquiries from all your online and campaigns",
        isImage: true,
        image: imageMarketing,
        imagePosition: "left",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconAnnounce,
                title: "Automate WhatsApp, email and sms marketing",
                text: "Sync enquiries from all real estate marketplace -99Acres, CommonFloor, MagicBricks, Housing, Makaan, Property Bazaar, JustDial and Other through direct connector or APIs",
            },
            {
                icon: iconEditPencil,
                title: "Create Amazing Campaigns",
                text: "Capture all enquiries from your website, Youtube, Facebook, Linkedln and others, directly using landing pages and plug-nad-play social integrations.",
            }
        ],
        rightIconWithText: null
    },
    {
        title: "Frontend Helpdesk",
        subtitle: "Improve Sales and Profitability with our brand new contact management",
        isImage: true,
        image: imageHelpDesk,
        imagePosition: "right",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconHeadPhone,
                title: "Reaching out to your Customers",
                text: "Our CRM provide outbond call integration so that you can easily reach out to your customers with one simple click.",
            },
            {
                icon: iconRefresh,
                title: "Convert Visitors to Leads",
                text: "Gather the personal data of website visitors and Generate Leads.",
            },
            {
                icon: iconWeb,
                title: "Sync Your Inquiries to Helpdesk",
                text: "Effortlessly sync inquiries from platforms like 99 Acres, CommonFloor, MagicBricks, Housing, Makaan, Property Bazaar, JustDial, and others through direct connectors or APIs, ensuring no lead is missed.",
            }
        ],
        rightIconWithText: null
    },
    {
        title: "Networking",
        subtitle: "Capture Property Inquiries from All Your Online and Offline Campaigns",
        isImage: true,
        image: imageNetworking,
        imagePosition: "left",
        coloredBG: false,
        leftIconWithText: [
            {
                icon: iconUserGroup,
                title: "Connect With agent",
                text: "Get connected to agents who may have properties or enquiries relevant to you",
            },
            {
                icon: iconNavigationBoard,
                title: "Explore and invite",
                text: "Explore agent networks and invite them for site visit",
            },
            {
                icon: iconGrow,
                title: "Grow your business",
                text: "Grow your network to expand your business.",
            }
        ],
        rightIconWithText: null
    }
];
export default WorksData;
